import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ isOpen, children, onClose }) => {
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.keyCode === 27) onClose(); // 27 es el código de la tecla ESC
    };

    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }

    // Función de limpieza para remover el event listener
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]); // Dependencias: se vuelve a ejecutar si isOpen o onClose cambian

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {children}
        <button className='button' onClick={onClose}>Cerrar</button>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default Modal;
